import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getFilteredArticles as filter } from "@routes/BreakingNews/utils/helpers";
import { BreakingNewsArticleProps } from "@routes/BreakingNews/utils/types";
import { isEmpty } from "lodash-es";

type UseGetBreakingNewsArticleProps = {
  today: BreakingNewsArticleProps[];
  yesterday: BreakingNewsArticleProps[];
  thedaybefore: BreakingNewsArticleProps[];
};

export const useGetBreakingNewsArticle = ({
  today,
  yesterday,
  thedaybefore,
}: UseGetBreakingNewsArticleProps) => {
  const [articles, setArticles] = useState<{
    today: BreakingNewsArticleProps[];
    yesterday: BreakingNewsArticleProps[];
    thedaybefore: BreakingNewsArticleProps[];
    activeFilter: string | null;
  }>({
    today,
    yesterday,
    thedaybefore,
    activeFilter: null,
  });
  const { search } = useLocation();

  const activeFilter = new URLSearchParams(search).get("filter");

  useEffect(() => {
    if (activeFilter === null) return;
    if (isEmpty(activeFilter)) return;

    const todayArticles = filter(today, activeFilter);
    const yesterdaysArticles = filter(yesterday, activeFilter);
    const thedaybeforesArticles = filter(thedaybefore, activeFilter);

    setArticles({
      today: todayArticles,
      yesterday: yesterdaysArticles,
      thedaybefore: thedaybeforesArticles,
      activeFilter,
    });
  }, [today, yesterday, thedaybefore, activeFilter]);

  return { articles };
};
